<template>
  <aside class="reservation-time__container" v-if="expiryTime && cart.timerHasBeenSet">
    <div class="reservation-time">
      <p class="cart-expiry">
        {{ $t("timer.timer_text_1") }} {{ expiryTime }}
        {{ $t("timer.timer_text_2") }}
      </p>
    </div>
    <modal-cart-time-warning />
  </aside>
</template>

<script>
import moment from "moment";
import momenttimezone from "moment-timezone";
import ModalCartTimeWarning from "@/components/modals/ModalCartTimeWarning";
import { mapActions, mapState } from "vuex";

export default {
  name: "timer",
  components: {
    ModalCartTimeWarning,
  },
  data() {
    return {
      expiryTime: null,
      timerOn: false,
      timerIntervalId: "",
    };
  },
  mounted() {
    this.startTimerCheck();
  },
  beforeUpdate() {
    this.startTimerCheck();
  },
  watch: {
    expiryTime() {
      if (!this.expiryTime && this.timerIntervalId) {
        clearInterval(this.timerIntervalId);
        this.destroyCartInstance("timeout")
      }
    },
    "$store.state.cart.cartExpiryTime": function() {
      this.startTimerCheck();
    }
  },
  computed: {
    ...mapState(['cart'])
  },
  methods: {
    startTimerCheck() {
      // We want to run this only once, otherwise it calls
      // the setInterval multiple times which can leak resources.
      // Until it is cleared, it should run the timer on the first setInterval.
      if (!this.timerOn && this.cart.cartExpiryTime) {
        this.timerOn = true;
        this.setTimer();
      }
    },
    setTimer() {
      // The timer starts based on the first ticket added and does not update regardless
      // of new tickets added.

      // self = this, due to "this" being relative to the setInterval function below
      const self = this;

      const timerIntervalId = setInterval(function() {
        // Make sure to have this on when the setTimer run (even after a page reload).

        let timeNow = new moment().tz('Asia/Hong_Kong');
        self.expiryTime = momenttimezone(self.cart.cartExpiryTime).tz('Asia/Hong_Kong').diff(
          timeNow
        );

        // If the now is later than the expiry time, the diff goes below 0,
        // and we want to reset the cart.
        if (self.expiryTime !== null && self.expiryTime < 0) {
          clearInterval(self.timerIntervalId);
          self.destroyCartInstance("timeout");
        } else {
          self.expiryTime = new momenttimezone(self.expiryTime).tz('Asia/Hong_Kong').format("mm:ss");

          /*
           * This seems brittle, but it's more accurate than targeting the raw moment
           * the raw moment factors milliseconds into account, which aren't
           * necessarily the same values on each instance of the timer (as I found out...)
           */
          if (self.expiryTime == "05:00") {
            self.$modal.show("modal-cart-time-warning");
          }
        }
      }, 1000);
      this.timerIntervalId = timerIntervalId;
    },
    ...mapActions(['destroyCartInstance'])
  },
};
</script>
